module.exports = __webpack_public_path__ + "img/stock2.f071c5e1.png";